import { render, staticRenderFns } from "./DocumentHistoryTable.vue?vue&type=template&id=c9ee83fc&"
import script from "./DocumentHistoryTable.vue?vue&type=script&lang=js&"
export * from "./DocumentHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports